/** A template another page asked the Templates page to open, consumed once its list loads. */
import { create } from "zustand";

export const useTemplateFocus = create<{ templateId?: string }>(() => ({}));

export const requestTemplateOpen = (templateId: string) => useTemplateFocus.setState({ templateId });
